import { render, staticRenderFns } from "./ArticleReview.vue?vue&type=template&id=7ae04722&"
import script from "./ArticleReview.vue?vue&type=script&lang=js&"
export * from "./ArticleReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports